<template>
  <component :is="template"></component>
</template>

<script>
import { STORE_KEY } from "./_store/constants";
import store from "./_store";
import ExamPurchase from "./_components/ExamPurchase";
import ExamPurchaseConfirm from "./_components/ExamPurchaseConfirm";
import ExamDetail from "./_components/ExamDetail";
import ExamResult from "./_components/ExamResult";
import ExamResultDetail from "./_components/ExamResultDetail";
import ExamResponse from "./_components/ExamResponse";
import ExamCategory from "./_components/ExamCategory";
import ExamPreviewResponse from "./_components/ExamPreviewResponse";

export default {
  name: "ExamModule",
  components: {
    ExamPurchase,
    ExamPurchaseConfirm,
    ExamDetail,
    ExamResult,
    ExamResultDetail,
    ExamResponse,
    ExamCategory,
    ExamPreviewResponse
  },
  props: {
    template: String
  },
  created() {
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }
}
</script>
